import axios from "axios"

export default {
    MainGroup:{
        async Table(data){
            const response = await axios.post(`/api/maintenanceinventoryoperations/maingroup/table`,data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/maintenanceinventoryoperations/maingroup/delete/${data}`)
            return response
        },
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? '/api/maintenanceinventoryoperations/maingroup/update' : '/api/maintenanceinventoryoperations/maingroup/create',data)
            return response
        },
        async List(){
            const response = await axios.get(`/api/maintenanceinventoryoperations/maingroup/select/list`)
            return response
        }
    },
    SubGroup:{
        async Table(data){
            const response = await axios.post(`/api/maintenanceinventoryoperations/subgroup/table`,data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/maintenanceinventoryoperations/subgroup/delete/${data}`)
            return response
        },
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? '/api/maintenanceinventoryoperations/subgroup/update' : '/api/maintenanceinventoryoperations/subgroup/create',data)
            return response
        },
        async List(data){
            const response = await axios.get(`/api/maintenanceinventoryoperations/subgroup/select/list/${data}`)
            return response
        }
    },
    PartOf:{
        async Table(data){
            const response = await axios.post(`/api/maintenanceinventoryoperations/part/table`,data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/maintenanceinventoryoperations/part/delete/${data}`)
            return response
        },
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? '/api/maintenanceinventoryoperations/part/update' : '/api/maintenanceinventoryoperations/part/create',data)
            return response
        },
    }
}